<template>
    <div class="md:container">
        <div class="flex flex-col shadow md:rounded-t-lg overflow-hidden">
            <AssetCdnImage
                :src="background ?? '/images/backgrounds/background-yellow-shape-2.svg'"
                layout="fullWidth"
                height="208"
                class="company-header"
            />
            <div class="bg-white">
                <div class="flex flex-col md:flex-row md:px-6 border-b border-solid border-slate-200">
                    <AssetCdnImage
                        v-if="logo"
                        :src="logo"
                        :width="screen.minMD ? 160 : 96"
                        :height="screen.minMD ? 160 : 96"
                        layout="fixed"
                        object-fit="contain"
                        class="bg-white shadow rounded-lg -mt-10 md:-mt-20 mx-auto md:mx-0"
                    />
                    <div
                        :class="[
                            'flex flex-col text-center md:text-left max-md:container md:px-0 items-center md:items-start mb-7 md:mb-6 md:ml-6',
                            logo ? 'mt-3' : 'mt-7',
                        ]"
                    >
                        <h1
                            style="word-break: normal !important; font-size: clamp(30px, 4.5vw, 36px) !important"
                            class="font-display-3 md:font-display-2"
                            v-text="company.name"
                        ></h1>
                        <span
                            v-if="company && company.slogan && company.slogan.length > 0"
                            v-line-clamp="2"
                            style="word-break: break-word !important"
                            class="mt-4 md:mt-2"
                            v-text="company.slogan"
                        ></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <CompanyShowHeaderMenu />
</template>

<script>
import { mapGetters } from 'vuex';
import { toRef } from 'vue';
import { useScreenSize } from '@/composables/screenSize';
import { getLogo, getBackground } from '@/utils/companyUtils';
import CompanyShowHeaderMenu from './CompanyShowHeaderMenu.vue';

export default {
    name: 'CompanyShowHeader',
    components: {
        CompanyShowHeaderMenu,
    },
    setup: () => ({
        screen: toRef(useScreenSize()),
    }),
    computed: {
        ...mapGetters({
            company: 'company/currentCompany',
        }),
        background() {
            return getBackground(this.company);
        },
        logo() {
            return getLogo(this.company);
        },
    },
};
</script>
